// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__1FiQJ","additionalInfo":"AgreementModal_additionalInfo__2xweE"};